import React from "react"
import { Link } from "gatsby"

const Pagination = ({ pageContext }) => {
  const taxonomySlug =
    pageContext.type === "category"
      ? pageContext.catSlug[0]
      : pageContext.tagSlug[0]
  return (
    <nav className="navigation pagination" role="navigation" aria-label="投稿">
      {pageContext.currentPage !== 1 && (
        <Link
          to={`/${pageContext.type}/${taxonomySlug}`}
          className="page-numbers"
        >
          <span aria-current="page" className="page-numbers">
            1
          </span>
        </Link>
      )}
      {pageContext.currentPage > 4 && (
        <span className="page-numbers dots">…</span>
      )}
      {pageContext.currentPage > 3 && (
        <Link
          to={`/${pageContext.type}/${taxonomySlug}/page/${
            pageContext.currentPage - 2
          }/`}
          className="page-numbers"
        >
          {pageContext.currentPage - 2}
        </Link>
      )}
      {pageContext.currentPage > 2 && (
        <Link
          to={`/${pageContext.type}/${taxonomySlug}/page/${
            pageContext.currentPage - 1
          }/`}
          className="page-numbers"
        >
          {pageContext.currentPage - 1}
        </Link>
      )}
      <span aria-current="page" className="page-numbers current">
        {pageContext.currentPage}
      </span>
      {pageContext.currentPage + 1 < pageContext.pages && (
        <Link
          to={`/${pageContext.type}/${taxonomySlug}/page/${
            pageContext.currentPage + 1
          }/`}
          className="page-numbers"
        >
          {pageContext.currentPage + 1}
        </Link>
      )}
      {pageContext.currentPage + 2 < pageContext.pages && (
        <Link
          to={`/${pageContext.type}/${taxonomySlug}/page/${
            pageContext.currentPage + 2
          }/`}
          className="page-numbers"
        >
          {pageContext.currentPage + 2}
        </Link>
      )}
      {pageContext.currentPage + 3 < pageContext.pages && (
        <span className="page-numbers dots">…</span>
      )}
      {!pageContext.isLast && (
        <Link
          to={`/${pageContext.type}/${taxonomySlug}/page/${pageContext.pages}/`}
          className="page-numbers"
        >
          {pageContext.pages}
        </Link>
      )}
    </nav>
  )
}

export default Pagination
